import { render, staticRenderFns } from "./TopLayerMenu.vue?vue&type=template&id=aacc75d0&"
import script from "./TopLayerMenu.vue?vue&type=script&lang=ts&"
export * from "./TopLayerMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports